<template>
    <div class="min-h-screen">
        <!-- <div style="position: relative;">
            <img style="width: 100%;image-rendering: pixelated;" src="../../assets/AI/AI_02.jpg" inferSize
                alt="我们的理念" />
            <div
                style="width:1200px;padding-left: 35px;margin: 0px auto;top: 0px;left: 0px;right: 0px;position: absolute;left: 0px;top: 0px;right: 0px;    height: 100%;display: flex;align-items: center;">
                <div>
                    <div style="font-size: 40px;">DeepSeek落地解决方案</div>
                    <div style="font-size: 16px;margin-top: 30px;color: #666;width: 600px;line-height: 28px;">
                        提供覆盖模型开发全生命周期的完整技术栈，通过整合模型构建平台与应用开发平台，实现从模型训练、部署优化、API服务发布到业务场景落地的端到端闭环，为企业打造“训练-推理-应用”无缝衔接的一站式AI服务体系，大幅降低技术整合复杂度，确保数据安全的同时提升业务迭代效率。
                    </div>
                </div>
            </div>
        </div> -->
        <div>
            <img style="image-rendering: pixelated;" src="../../assets/AI/9AI-改3_02.jpg" inferSize alt="我们的理念" />
        </div>
        <div style="margin-top: 50px;">
            <div>
                <h2 class="text-center" style="font-size:28px;">AI大模型落地解决方案</h2>
            </div>
            <div style="margin-top: 35px;height: 230px;padding:40px 0px;"
                :style="{ backgroundImage: 'url(' + require('@/assets/AI/9AI-改3_04.jpg') + ')' }">
                <div style="font-size: 24px; font-weight: bold;color: #fff;text-align: center;">从方案到实施服务的全方位智能应用落地</div>
                <div
                    style="font-size: 16px;color: #fff;width: 1100px;line-height: 28px;margin: 0px auto;margin-top: 28px;">
                    致力于从平台、应用到服务的全链条智能落地，通过提供行业领先的私有化与定制化智能体开发平台，支持智能体构建、系统集成、AI应用开发及知识库与模型调优，为质检、审核等工作流场景配备AI助手与智能体，实现业务自动化与智能决策；方案深度融合数据清洗、AI训练、模型调优及私有化部署等全方位服务，让AI真正成为企业的数智员工，更懂业务、更懂企业，最终助力客户沉淀知识资产，实现业务加速与降本增效的一站式AI落地价值。
                </div>
            </div>
        </div>
        <div class="relative">
            <img style="height: 600px;margin: 0px auto;" src="../../assets/AI/AI_03.jpg" inferSize alt="我们的理念" />
            <div style="height: 100%;width: 100%;top: 0px;position: absolute;">
                <h2 class="text-center" style="font-size:28px;margin-top: 80px;">企业为什么要接入AI？</h2>
                <div
                    style="margin: 0px auto;margin-top: 55px;height: 60px;width: 480px;text-align: center;line-height: 60px;background: #1e66d1;color: #fff;border-radius: 30px;font-size: 24px;">
                    从“人力驱动”到“智能驱动”的进化
                </div>
                <div style="text-align: center;margin-top: 40px;font-size: 16px;line-height: 2;">
                    <pre>接入AI不再是“锦上添花”，而是关乎企业能否在“数据驱动”的新时代生存与领跑的关键。
AI，正在深刻重构生产要素、重塑生产流程、创造全新价值。它是颠覆传统生产方式、释放数据价值的革命性引擎。</pre>
                </div>
                <div
                    style="display: flex;justify-content: space-around;width: 1200px;margin: 0px auto;margin-top: 55px;">
                    <div
                        style="width: 350px;color: #1e66d1;border: 1px dashed #1e66d1;height: 88px;font-size: 16px;border-radius: 15px;display:flex; justify-content: center;align-items: center;text-align: center;background: #fff;font-weight: bold;">
                        <div>
                            <div>数据成为核心生产资料</div>
                            <div>AI是唯一能“盘活”它的引擎</div>
                        </div>
                    </div>
                    <div
                        style="width: 350px;color: #1e66d1;border: 1px dashed #1e66d1;height: 88px;font-size: 16px;border-radius: 15px;display:flex; justify-content: center;align-items: center;text-align: center;background: #fff;font-weight: bold;">
                        <div>
                            <div>自动化从“体力/流程”升维至</div>
                            <div>“认知/决策”</div>
                        </div>
                    </div>
                    <div
                        style="width: 350px;color: #1e66d1;border: 1px dashed #1e66d1;height: 88px;font-size: 16px;border-radius: 15px;display:flex; justify-content: center;align-items: center;text-align: center;background: #fff;font-weight: bold;">
                        <div>
                            <div>重塑产品、服务与商业模式</div>
                            <div>创造前所未有的价值</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div style="position: relative;padding-bottom: 50px;">
            <div style="position: relative;z-index: 9;">
                <div style="font-size: 28px;text-align: center;">服务方案</div>
                <div style="margin-top: 30px;font-size: 16px;text-align:center ;">
                    从方案到实施服务的全方位智能应用落地</div>
                <div style="width: 886px;margin: 0px auto;margin-top: 80px;">
                    <div style="display: flex;align-items: center;justify-content: space-between;">
                        <div>
                            <div
                                style="background: #fff; border: 1px dashed #1e66d1;width: 170px;height: 220px;text-align: center;border-radius: 10px;">
                                <div style="background: #1e66d1;border-radius:50%;height: 90px;width: 90px;color: #fff;text-align: center;line-height: 90px;font-size: 24px;font-weight: bold;margin: 0px auto;
    margin-top: -45px;">
                                    平台</div>
                                <div style="color: #1e66d1;font-weight: bold; font-size: 16px;margin-top: 10px;">开发平台
                                </div>
                                <div style="font-size: 14px;margin-top: 5px;">工作流</div>
                                <div style="font-size: 14px;margin-top: 5px;">Agent</div>
                                <div style="font-size: 14px;margin-top: 5px;">知识库</div>
                                <div style="font-size: 14px;margin-top: 10px;">......</div>
                            </div>
                        </div>
                        <div style="font-size: 48px;">+</div>
                        <div>
                            <div
                                style="background: #fff;border: 1px dashed #3fb337;width: 170px;height: 220px;text-align: center;border-radius: 10px;">
                                <div style="background: #3fb337;border-radius:50%;height: 90px;width: 90px;color: #fff;text-align: center;line-height: 90px;font-size: 24px;font-weight: bold;margin: 0px auto;
    margin-top: -45px;">
                                    应用</div>
                                <div style="color: #3fb337;font-weight: bold; font-size: 16px;margin-top: 10px;">应用场景
                                </div>
                                <div style="font-size: 14px;margin-top: 5px;">AI质检助手</div>
                                <div style="font-size: 14px;margin-top: 5px;">AI审核助手</div>
                                <div style="font-size: 14px;margin-top: 5px;">AI知识库</div>
                                <div style="font-size: 14px;margin-top: 10px;">......</div>
                            </div>
                        </div>
                        <div style="font-size: 48px;">+</div>
                        <div>
                            <div
                                style="background: #fff;border: 1px dashed #e17933;width: 170px;height: 220px;text-align: center;border-radius: 10px;">
                                <div style="background: #e17933;border-radius:50%;height: 90px;width: 90px;color: #fff;text-align: center;line-height: 90px;font-size: 24px;font-weight: bold;margin: 0px auto;
    margin-top: -45px;">
                                    服务</div>
                                <div style="color: #e17933;font-weight: bold; font-size: 16px;margin-top: 10px;">落地服务
                                </div>
                                <div style="font-size: 14px;margin-top: 5px;">数据清洗</div>
                                <div style="font-size: 14px;margin-top: 5px;">AI训练</div>
                                <div style="font-size: 14px;margin-top: 5px;">模型调优</div>
                                <div style="font-size: 14px;margin-top: 10px;">......</div>
                            </div>
                        </div>
                        <div style="font-size: 48px;">=</div>
                        <div>
                            <div
                                style="background: #fff;border: 1px dashed #333;width: 170px;height: 220px;text-align: center;border-radius: 10px;">
                                <div style="background: #fff;border: 1px dashed #333;border-radius:50%;height: 90px;width: 90px;color: #333;text-align: center;line-height: 30px;font-size: 24px;font-weight: bold;margin: 0px auto;
    margin-top: -45px;    padding: 13px 10px;">
                                    <div>
                                        用户价值
                                    </div>
                                </div>
                                <div style="font-weight: bold; font-size: 16px;margin-top: 10px;">一站式AI落地</div>
                                <div style="font-weight: bold; font-size: 16px;margin-top: 10px;">为客户实现</div>
                                <div style="font-weight: bold; font-size: 16px;margin-top: 10px;">智能业务加速</div>
                            </div>
                        </div>
                    </div>
                    <div
                        style="height: 100px;padding:0px 20px; background: #1e66d1;margin-top: 30px;border-radius: 10px;display: flex;align-items: center;justify-content: space-between;">
                        <div style="display: flex;align-items: center;">
                            <div>
                                <img src="../../assets/AI/_Compound Path_.png" style="margin:0px auto;width: 35px;">
                            </div>
                            <div style="font-size: 14px;color: #fff;margin-left: 10px;width: 200px;">
                                提供行业领先的、私有化&SAAS智能体开发平台
                            </div>
                        </div>
                        <div style="display: flex;align-items: center;">
                            <div>
                                <img src="../../assets/AI/_Compound Path1.png" style="margin:0px auto;width: 35px;">
                            </div>
                            <div style="font-size: 14px;color: #fff;margin-left: 10px;width: 200px;">
                                提供智能体构建、系统集成、AI应用开发
                            </div>
                        </div>
                        <div style="display: flex;align-items: center;">
                            <div>
                                <img src="../../assets/AI/_Compound Path2.png" style="margin:0px auto;width: 35px;">
                            </div>
                            <div style="font-size: 14px;color: #fff;margin-left: 10px;width: 200px;">
                                提供从方案到实施至售后的全方位服务
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <img src="../../assets/AI/9AI-改3_07.jpg" style="position: absolute;bottom: -30px;width: 100%;height: 100%;">
        </div>


        <div style="margin-top: 80px;">
            <div style="font-size: 28px;text-align: center;">企业AI智能体中台</div>
            <div style="margin:0px auto;margin-top: 25px;font-size: 16px;text-align: center;">
                大模型的应用开发平台，提供RAG、Workflow、Agent框架，助力企业加速大模型应用落地</div>
            <div>
                <img src="../../assets/AI/ai133.png" style="margin:0px auto;">
            </div>
            <div style="margin: 0px auto;width: 1200px;margin-top: 50px;">
                <div style="display: flex;align-items: center;font-weight: bold;color: #1e66d1;">
                    <div style="font-size: 26px;margin-left: 30px;">系统结构</div>
                    <div style="margin-left: 30px;font-size: 16px;margin-top: 3px;">智能体开发平台</div>
                </div>
                <div style="width: 100%;height: 5px;background: #1e66d1;margin-top: 10px;"></div>
            </div>
            <div style="display: flex;width: 1200px;margin:0px auto;padding: 50px;">
                <div style="width: 55%;">
                    <img src="../../assets/AI/tuceng74.png">
                </div>
                <div style="margin: 0px auto;margin-top: 20px;">
                    <div>
                        <div
                            style="width: 390px;height: 40px;line-height: 40px;color: #fff;background: #1e66d1;border-radius: 20px;font-size: 16px;padding-left: 20px;">
                            RAG框架：效果保持领先，解析检索工具沉淀丰富
                        </div>
                        <div style="font-size: 14px;margin-top: 20px;width: 370px;margin-left:10px ;">依托领先 RAG
                            框架，融合多源解析与精准检索能力沉淀丰富工具集，显著提升智能体回答的准确率与专业度。</div>
                    </div>
                    <div style="margin-top: 45px;">
                        <div
                            style="width: 390px;height: 40px;line-height: 40px;color: #fff;background: #1e66d1;border-radius: 20px;font-size: 16px;padding-left: 20px;">
                            WorkFlow框架：工作流复杂应用构建能力
                        </div>
                        <div style="font-size: 14px;margin-top: 20px;width: 370px;margin-left:10px ;">
                            基于强大的 Workflow 框架，提供可视化编排能力，支持构建逻辑复杂的自动化工作流，轻松应对企业级业务场景的定制需求。</div>
                    </div>
                    <div style="margin-top: 45px;">
                        <div
                            style="width: 390px;height: 40px;line-height: 40px;color: #fff;background: #1e66d1;border-radius: 20px;font-size: 16px;padding-left: 20px;">
                            Agent框架：支持多Agent智能转交协同
                        </div>
                        <div style="font-size: 14px;margin-top: 20px;width: 370px;margin-left:10px ;">
                            基于灵活的 Agent 框架，支持多智能体智能转交与协同工作，通过专业分工解决复杂问题，实现更高效的任务处理闭环。</div>
                    </div>
                </div>
            </div>
        </div>

        <div style="margin: 0px auto;width: 1200px;margin-top: 50px;">
            <div style="position: relative;z-index: 9;background: #fff;">
                <div style="display: flex;align-items: center;font-weight: bold;color: #1e66d1;">
                    <div style="font-size: 26px;margin-left: 30px;">可视化工作流任务编排</div>
                    <div style="margin-left: 30px;font-size: 16px;margin-top: 3px;">拖拽之间，轻松实现业务自动化</div>
                </div>
                <div style="width: 100%;height: 5px;background: #1e66d1;margin-top: 10px;"></div>
            </div>
            <div style="position: relative;height: 500px;">
                <img src="../../assets/AI/tuceng1.png" style="position: relative;top: -110px;">
            </div>
        </div>

        <div style="margin: 0px auto;width: 1200px;margin-top: 80px;">
            <div style="display: flex;align-items: center;font-weight: bold;color: #1e66d1;">
                <div style="font-size: 26px;margin-left: 30px;">知识库</div>
                <div style="margin-left: 30px;font-size: 16px;margin-top: 3px;">构建企业智慧大脑的基石</div>
            </div>
            <div style="width: 100%;height: 5px;background: #1e66d1;margin-top: 10px;"></div>
        </div>
        <div style="display: flex;width: 1200px;margin:0px auto;padding: 30px;">
            <div style="width: 70%;position: relative;">
                <img src="../../assets/AI/Background.png">
            </div>
            <div style="margin: 0px auto;margin-top: 10px;position: relative;z-index: 9;">
                <div>
                    <div
                        style="width: 280px;height: 40px;line-height: 40px;color: #fff;background: #1e66d1;border-radius: 20px;font-size: 16px;padding-left: 20px;">
                        多源数据导入
                    </div>
                    <div style="font-size: 14px;margin-top: 20px;width: 270px;margin-left:10px ;">
                        支持从文本、文档、网页等多种来源导入知识。</div>
                </div>
                <div style="margin-top: 25px;">
                    <div
                        style="width: 280px;height: 40px;line-height: 40px;color: #fff;background: #1e66d1;border-radius: 20px;font-size: 16px;padding-left: 20px;">
                        智能分块与向量化
                    </div>
                    <div style="font-size: 14px;margin-top: 20px;width: 270px;margin-left:10px ;">
                        自动对文档进行智能分块，并将其转换为向量存储，以便快速检索。</div>
                </div>
                <div style="margin-top: 25px;">
                    <div
                        style="width: 280px;height: 40px;line-height: 40px;color: #fff;background: #1e66d1;border-radius: 20px;font-size: 16px;padding-left: 20px;">
                        灵活的检索策略
                    </div>
                    <div style="font-size: 14px;margin-top: 20px;width: 270px;margin-left:10px ;">
                        支持关键词、向量及混合检索，确保快速找到相关信息。</div>
                </div>
                <div style="margin-top: 25px;">
                    <div
                        style="width: 280px;height: 40px;line-height: 40px;color: #fff;background: #1e66d1;border-radius: 20px;font-size: 16px;padding-left: 20px;">
                        版本控制与管理
                    </div>
                    <div style="font-size: 14px;margin-top: 20px;width: 270px;margin-left:10px ;">
                        版本迭代基础上进行各版本精细化管理。</div>
                </div>
            </div>
        </div>

        <div style="margin: 0px auto;width: 1200px;margin-top: 80px;">
            <div style="display: flex;align-items: center;font-weight: bold;color: #1e66d1;">
                <div style="font-size: 26px;margin-left: 30px;">自主智能体(Agent)</div>
                <div style="margin-left: 30px;font-size: 16px;margin-top: 3px;">迈向自主智能的未来：AI Agent 驱动业务自动化</div>
            </div>
            <div style="width: 100%;height: 5px;background: #1e66d1;margin-top: 10px;"></div>
        </div>
        <div style="display: flex;width: 1200px;margin:0px auto;padding: 30px;">
            <div style="width: 50%; display: flex;flex-wrap: wrap;">
                <div
                    style="height: 100px;width: 240px;border: 1px solid #1e66d1;text-align: center;margin: 5px;border-radius: 10px;padding: 0px 10px;">
                    <div style="font-size: 18px;font-weight: bold;color: #1e66d1;margin-top: 10px;">AI知识库</div>
                    <div style="font-size: 14px;margin-top: 10px;text-align: left;padding-left: 5px;">整合多源数据，构建企业知识中枢</div>
                </div>
                <div
                    style="height: 100px;width: 240px;border: 1px solid #1e66d1;text-align: center;margin: 5px;border-radius: 10px;padding: 0px 10px;">
                    <div style="font-size: 18px;font-weight: bold;color: #1e66d1;margin-top: 10px;">AI智能客服</div>
                    <div style="font-size: 14px;margin-top: 10px;text-align: left;padding-left: 5px;">生成式Al全渠道智能对话，提升服务效率</div>
                </div>
                <div
                    style="height: 100px;width: 240px;border: 1px solid #1e66d1;text-align: center;margin: 5px;border-radius: 10px;padding: 0px 10px;">
                    <div style="font-size: 18px;font-weight: bold;color: #1e66d1;margin-top: 10px;">AI智能预警</div>
                    <div style="font-size: 14px;margin-top: 10px;text-align: left;padding-left: 5px;">无人机+AI图像识别，实时预警安全隐患</div>
                </div>
                <div
                    style="height: 100px;width: 240px;border: 1px solid #1e66d1;text-align: center;margin: 5px;border-radius: 10px;padding: 0px 10px;">
                    <div style="font-size: 18px;font-weight: bold;color: #1e66d1;margin-top: 10px;">AI舆情监测</div>
                    <div style="font-size: 14px;margin-top: 10px;text-align: left;padding-left: 5px;">监测企业微信，智能分析敏感词预警风险</div>
                </div>
                <div
                    style="height: 100px;width: 240px;border: 1px solid #1e66d1;text-align: center;margin: 5px;border-radius: 10px;padding: 0px 10px;">
                    <div style="font-size: 18px;font-weight: bold;color: #1e66d1;margin-top: 10px;">招标助手</div>
                    <div style="font-size: 14px;margin-top: 10px;text-align: left;padding-left: 5px;">智能解析招标文件，对比投标偏差，提升效率</div>
                </div>
                <div
                    style="height: 100px;width: 240px;border: 1px solid #1e66d1;text-align: center;margin: 5px;border-radius: 10px;padding: 0px 10px;">
                    <div style="font-size: 18px;font-weight: bold;color: #1e66d1;margin-top: 10px;">会议纪要生成器</div>
                    <div style="font-size: 14px;margin-top: 10px;text-align: left;padding-left: 5px;">自动整理会议内容，提取决议与待办事项</div>
                </div>
                <div
                    style="height: 100px;width: 240px;border: 1px solid #1e66d1;text-align: center;margin: 5px;border-radius: 10px;padding: 0px 10px;">
                    <div style="font-size: 18px;font-weight: bold;color: #1e66d1;margin-top: 10px;">内部审计助手</div>
                    <div style="font-size: 14px;margin-top: 10px;text-align: left;padding-left: 5px;">协助内部审计，提供方案、清单及报告板</div>
                </div>
                <div
                    style="height: 100px;width: 240px;border: 1px solid #1e66d1;text-align: center;margin: 5px;border-radius: 10px;padding: 0px 10px;">
                    <div style="font-size: 18px;font-weight: bold;color: #1e66d1;margin-top: 10px;">政策法规解读</div>
                    <div style="font-size: 14px;margin-top: 10px;text-align: left;padding-left: 5px;">解读最新财经法规，辅助企业及时掌握政策变化</div>
                </div>
            </div>
            <div style="width: 55%;">
                <img src="../../assets/AI/Background3.png">
            </div>
        </div>

        <div style="margin-top: 60px;background: #f5f6f7;padding-bottom: 50px;">
            <div style="font-size: 28px;padding-top: 50px; text-align: center;">AI智能体应用</div>
            <div
                style="width: 1200px;margin: 0px auto;background-size: 100% 100%;margin-top: 30px;display: flex;flex-wrap: wrap;justify-content: space-between;">
                <div @click="tof('企业小龙虾')" style="width: 240px;" class="lifors pointer">
                    <div style="margin-top: 20px;"><img src="../../assets/home/ai11@2x.png"
                            style="margin:0px auto;height: 45px;">
                    </div>
                    <div style="font-size: 20px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        企业小龙虾</div>
                    <div
                        style="margin: 0px auto;font-size: 14px;margin-top: 30px;line-height: 30px;color: #333;height: 80px;width: 185px;">
                        企业级多智能体协同平台，自动化采集分析数据，驱动业务决策与洞察</div>
                    <div @click="toe" class="buttondh" style="margin: 30px auto;width: 110px;height: 36px;line-height: 36px;text-align: center;
                    border: 1px solid #1e66d1;border-radius: 30px;font-size: 14px;color: #1e66d1;cursor: pointer;">
                        产品详情>
                    </div>
                </div>
                <div @click="tof('AI舆情监测')" style="width: 240px;" class="lifors pointer">
                    <div style="margin-top: 20px;"><img src="../../assets/home/ai5@2x.png"
                            style="margin:0px auto;height: 45px;">
                    </div>
                    <div style="font-size: 20px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        AI舆情监测</div>
                    <div
                        style="margin: 0px auto;font-size: 14px;margin-top: 30px;line-height: 30px;color: #333;height: 80px;width: 185px;">
                        AI监测企业微信聊天，结合上下文分析敏感词意图，主动预警内部风险</div>
                    <div @click="toe" class="buttondh" style="margin: 30px auto;width: 110px;height: 36px;line-height: 36px;text-align: center;
                    border: 1px solid #1e66d1;border-radius: 30px;font-size: 14px;color: #1e66d1;cursor: pointer;">
                        产品详情>
                    </div>
                </div>
                <div @click="tof('智慧财务服务助手')" style="width: 240px;" class="lifors pointer">
                    <div style="margin-top: 20px;"><img src="../../assets/home/ai@2x.png"
                            style="margin:0px auto;height: 45px;">
                    </div>
                    <div style="font-size: 20px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        智慧财务服务助手</div>
                    <div
                        style="margin: 0px auto;font-size: 14px;margin-top: 30px;line-height: 30px;color: #333;height: 80px;width: 185px;">
                        AI财务助手，自然语言解答政策流程，支持进度查询与催办</div>
                    <div @click="toe" class="buttondh" style="margin: 30px auto;width: 110px;height: 36px;line-height: 36px;text-align: center;
                    border: 1px solid #1e66d1;border-radius: 30px;font-size: 14px;color: #1e66d1;cursor: pointer;">
                        产品详情>
                    </div>
                </div>
                <div @click="tof('AI知识库')" style="width: 240px;" class="lifors pointer">
                    <div style="margin-top: 20px;"><img src="../../assets/home/ai1@2x.png"
                            style="margin:0px auto;height: 45px;">
                    </div>
                    <div style="font-size: 20px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        AI知识库</div>
                    <div
                        style="margin: 0px auto;font-size: 14px;margin-top: 30px;line-height: 30px;color: #333;height: 80px;width: 185px;">
                        整合多源数据构建企业知识中枢，为AI应用提供精准语义化服务
                    </div>
                    <div @click="toe" class="buttondh" style="margin: 30px auto;width: 110px;height: 36px;line-height: 36px;text-align: center;
                    border: 1px solid #1e66d1;border-radius: 30px;font-size: 14px;color: #1e66d1;cursor: pointer;">
                        产品详情>
                    </div>
                </div>
                <div @click="tof('AI智能客服')" style="width: 240px;" class="lifors pointer">
                    <div style="margin-top: 20px;"><img src="../../assets/home/ai2@2x.png"
                            style="margin:0px auto;height: 45px;">
                    </div>
                    <div style="font-size: 20px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        AI智能客服</div>
                    <div
                        style="margin: 0px auto;font-size: 14px;margin-top: 30px;line-height: 30px;color: #333;height: 80px;width: 185px;">
                        基于生成式AI的全渠道对话引擎，实现服务与业务场景智能化</div>
                    <div @click="toe" class="buttondh" style="margin: 30px auto;width: 110px;height: 36px;line-height: 36px;text-align: center;
                    border: 1px solid #1e66d1;border-radius: 30px;font-size: 14px;color: #1e66d1;cursor: pointer;">
                        产品详情>
                    </div>
                </div>
                <div @click="tof('智能安防AI预警')" style="width: 240px;" class="lifors pointer">
                    <div style="margin-top: 20px;"><img src="../../assets/home/ai4@2x.png"
                            style="margin:0px auto;height: 45px;">
                    </div>
                    <div style="font-size: 20px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        智能安防AI预警</div>
                    <div
                        style="margin: 0px auto;font-size: 14px;margin-top: 30px;line-height: 30px;color: #333;height: 80px;width: 185px;">
                        无人机巡检结合AI图像识别，实时识别隐患并自动预警，提升安防响应速度</div>
                    <div @click="toe" class="buttondh" style="margin: 30px auto;width: 110px;height: 36px;line-height: 36px;text-align: center;
                    border: 1px solid #1e66d1;border-radius: 30px;font-size: 14px;color: #1e66d1;cursor: pointer;">
                        产品详情>
                    </div>
                </div>
                <div @click="tof('智能运维接管')" style="width: 240px;" class="lifors pointer">
                    <div style="margin-top: 20px;"><img src="../../assets/home/ai6@2x.png"
                            style="margin:0px auto;height: 45px;">
                    </div>
                    <div style="font-size: 20px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        智能运维接管</div>
                    <div
                        style="margin: 0px auto;font-size: 14px;margin-top: 30px;line-height: 30px;color: #333;height: 80px;width: 185px;">
                        AI分析报修描述，自动分流软件/硬件问题，提供自助排查建议，加速问题解决</div>
                    <div @click="toe" class="buttondh" style="margin: 30px auto;width: 110px;height: 36px;line-height: 36px;text-align: center;
                    border: 1px solid #1e66d1;border-radius: 30px;font-size: 14px;color: #1e66d1;cursor: pointer;">
                        产品详情>
                    </div>
                </div>
                <div @click="tof('网络日志智能报表')" style="width: 240px;" class="lifors pointer">
                    <div style="margin-top: 20px;"><img src="../../assets/home/ai7@2x.png"
                            style="margin:0px auto;height: 45px;">
                    </div>
                    <div style="font-size: 20px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        网络日志智能报表</div>
                    <div
                        style="margin: 0px auto;font-size: 14px;margin-top: 30px;line-height: 30px;color: #333;height: 80px;width: 185px;">
                        RPA+AI自动收集分析日志，生成带风险等级的安全报告，提升效率</div>
                    <div @click="toe" class="buttondh" style="margin: 30px auto;width: 110px;height: 36px;line-height: 36px;text-align: center;
                    border: 1px solid #1e66d1;border-radius: 30px;font-size: 14px;color: #1e66d1;cursor: pointer;">
                        产品详情>
                    </div>
                </div>
                <div @click="tof('招投标肋手')" style="width: 240px;" class="lifors pointer">
                    <div style="margin-top: 20px;"><img src="../../assets/home/ai8@2x.png"
                            style="margin:0px auto;height: 45px;">
                    </div>
                    <div style="font-size: 20px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        招投标肋手</div>
                    <div
                        style="margin: 0px auto;font-size: 14px;margin-top: 30px;line-height: 30px;color: #333;height: 80px;width: 185px;">
                        AI解析招标关键信息，比对投标偏差，辅助标书编写与投标前审核</div>
                    <div @click="toe" class="buttondh" style="margin: 30px auto;width: 110px;height: 36px;line-height: 36px;text-align: center;
                    border: 1px solid #1e66d1;border-radius: 30px;font-size: 14px;color: #1e66d1;cursor: pointer;">
                        产品详情>
                    </div>
                </div>
                <div @click="tof('施工技术方案智能审核平台')" style="width: 240px;" class="lifors pointer">
                    <div style="margin-top: 20px;"><img src="../../assets/home/ai9@2x.png"
                            style="margin:0px auto;height: 45px;">
                    </div>
                    <div style="font-size: 20px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        施工技术方案智能审核平台</div>
                    <div
                        style="margin: 0px auto;font-size: 14px;margin-top: 30px;line-height: 30px;color: #333;height: 80px;width: 185px;">
                        AI学习行业规范，自动审核施工方案参数，一键生成评审报告</div>
                    <div @click="toe" class="buttondh" style="margin: 30px auto;width: 110px;height: 36px;line-height: 36px;text-align: center;
                    border: 1px solid #1e66d1;border-radius: 30px;font-size: 14px;color: #1e66d1;cursor: pointer;">
                        产品详情>
                    </div>
                </div>
            </div>
        </div>

        <div style="margin-top: 90px;">
            <div style="text-align: center;font-size: 28px;">产品特性</div>
            <div style="display: flex;flex-wrap: wrap;width: 1200px;margin: 0px auto;justify-content: space-between;">
                <div style="margin-top: 65px;display: flex;width: 28%;">
                    <div><img src="../../assets/AI/cptx1@2x.png" style="width: 55px;"></div>
                    <div style="margin-left: 15px;flex: 1;">
                        <div style="font-size: 18px;color: #1e66d1;">私有化定制·安全可控</div>
                        <div style="font-size: 14px;margin-top: 5px;line-height: 25px;">
                            提供从快速部署、定制开发到安全防护的全面支持保障，支持私有化部署与字段级权限控制，满足医疗、金融、政务等行业合规要求，确保性价比心资产自主可控、全链路数据安全。
                        </div>
                    </div>
                </div>
                <div style="margin-top: 65px;display: flex;width: 28%;">
                    <div><img src="../../assets/AI/cptx2@2x.png" style="width: 55px;"></div>
                    <div style="margin-left: 15px;flex: 1;">
                        <div style="font-size: 18px;color: #1e66d1;">深度业务理解·数字员工</div>
                        <div style="font-size: 14px;margin-top: 5px;line-height: 25px;">
                            基于大模型实现自然语言交互与复杂语义解析，意图识别精准，让数字员工深度理解企业业务逻辑与行业术语，精准匹配知识内容，真正成为懂业务的智能助手。
                        </div>
                    </div>
                </div>
                <div style="margin-top: 65px;display: flex;width: 28%;">
                    <div><img src="../../assets/AI/cptx3@2x.png" style="width: 55px;"></div>
                    <div style="margin-left: 15px;flex: 1;">
                        <div style="font-size: 18px;color: #1e66d1;">统一管理·全链路打通</div>
                        <div style="font-size: 14px;margin-top: 5px;line-height: 25px;">
                            没有统一平台，AI应用将形成数据孤岛与能力烟囱，难以共享协同。本平台为所有应用提供统一的管理、开发与集成标准，实现从后台配置、中台调度到前台使用的全链路贯通，确保
                            AI能力无缝落地业务场景，并与企业现有系统高效对接。
                        </div>
                    </div>
                </div>
                <div style="margin-top: 65px;display: flex;width: 28%;">
                    <div><img src="../../assets/AI/cptx4@2x.png" style="width: 55px;"></div>
                    <div style="margin-left: 15px;flex: 1;">
                        <div style="font-size: 18px;color: #ff6600;">开箱即用·快速落地
                        </div>
                        <div style="font-size: 14px;margin-top: 5px;line-height: 25px;">
                            内置丰富的行业模板与预置方案，基于 Workflow 框架实现可视化流程编排，支持多轮追问与逻辑推理，从创意到落地快速实现，真正做到上手即用。
                        </div>
                    </div>
                </div>
                <div style="margin-top: 65px;display: flex;width: 28%;">
                    <div><img src="../../assets/AI/cptx5@2x.png" style="width: 55px;"></div>
                    <div style="margin-left: 15px;flex: 1;">
                        <div style="font-size: 18px;color: #ff6600;">行业沉淀·成熟可用</div>
                        <div style="font-size: 14px;margin-top: 5px;line-height: 25px;">
                            通过用户反馈闭环自动识别知识盲区并触发更新，模型持续迭代优化；同时积累各行业成功案例，将项目经验沉淀为可复用的行业解决方案，新客户可快速复用，实现成熟可用。
                        </div>
                    </div>
                </div>
                <div style="margin-top: 65px;display: flex;width: 28%;">
                    <div><img src="../../assets/AI/cptx6@2x.png" style="width: 55px;"></div>
                    <div style="margin-left: 15px;flex: 1;">
                        <div style="font-size: 18px;color: #ff6600;">高性能·高性价比</div>
                        <div style="font-size: 14px;margin-top: 5px;line-height: 25px;">
                            支持海量任务并发处理，复杂场景秒级响应，会话状态稳定可靠；同时提供成本优化保障，以极具竞争力的价格提供企业级高性能体验，助力客户大幅降本增效。
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div style="margin-top: 90px;background: #fefefe;padding-top: 68px;padding-bottom: 100px;">
            <div style="font-size: 28px;text-align: center;position: relative;z-index: 9;">提供全方位 AI 专业服务体系</div>
            <div style="position: relative;top: -110px;">
                <img src="../../assets/AI/9AI-改3_09.jpg" style="margin:0px auto;">
            </div>
            <div style="font-size: 28px;text-align: center;">多种部署模式，满足不同安全需求</div>
            <div style="display: flex;width: 1200px;margin:0px auto;padding: 50px;">
                <div style="width: 55%;">
                    <img src="../../assets/AI/Background4.png">
                </div>
                <div style="margin: 0px auto;margin-top: 20px;">
                    <div>
                        <div
                            style="width: 390px;height: 40px;color: #1e66d1;background: linear-gradient(to left, #ffffff, #d7e7ff);font-size: 16px;font-weight: bold;display: flex;align-items: center;">
                            <div style="background: #1e66d1;width: 5px;height: 40px;"></div>
                            <div style="margin-left: 10px;">多样化部署选择</div>
                        </div>
                        <div style="font-size: 14px;margin-top: 20px;width: 370px;margin-left:10px ;">
                            平台支持SaaS、混合云、全私有化三种模式。全私有化部署实现数据模型封闭管理，核心资产不泄露，满足高安全行业合规要求。
                        </div>
                    </div>
                    <div style="margin-top: 45px;">
                        <div
                            style="width: 390px;height: 40px;color: #1e66d1;background: linear-gradient(to left, #ffffff, #d7e7ff);font-size: 16px;font-weight: bold;display: flex;align-items: center;">
                            <div style="background: #1e66d1;width: 5px;height: 40px;"></div>
                            <div style="margin-left: 10px;">灵活适配业务需求</div>
                        </div>
                        <div style="font-size: 14px;margin-top: 20px;width: 370px;margin-left:10px ;">
                            SaaS模式快速上线，混合云平衡安全与弹性。全私有化可基于企业数据定向优化，精准识别行业术语，关键任务准确率大幅提升。</div>
                    </div>
                    <div style="margin-top: 45px;">
                        <div
                            style="width: 390px;height: 40px;color: #1e66d1;background: linear-gradient(to left, #ffffff, #d7e7ff);font-size: 16px;font-weight: bold;display: flex;align-items: center;">
                            <div style="background: #1e66d1;width: 5px;height: 40px;"></div>
                            <div style="margin-left: 10px;">技术赋能高效落地</div>
                        </div>
                        <div style="font-size: 14px;margin-top: 20px;width: 370px;margin-left:10px ;">
                            多种部署模式确保灵活扩展。私有化部署支持本地GPU集群毫秒级响应，断网仍可运行，保障业务连续性，杜绝技术泄密风险。</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div style="margin-top: 90px;background: #f5f5f5;padding-top: 68px;padding-bottom: 100px;">
            <div style="font-size: 28px;text-align: center;">提供全方位 AI 专业服务体系</div>
            <div style="margin-top: 30px;">
                <img src="../../assets/AI/AI_06.jpg" style="margin:0px auto;">
            </div>
            <div style="margin-top: 85px;font-size: 28px;text-align: center;">私有化部署优势</div>
            <div>
                <img src="../../assets/AI/AI_13.jpg" style="margin:0px auto;">
            </div>
            <div style="background: #fff;width: 1200px;display: flex;margin: 0px auto;">
                <div style="height: 300px;width: 340px;padding: 0px 20px;">
                    <div style="margin-top: 35px;"><img src="../../assets/AI/AI_15.png"
                            style="margin:0px auto;height: 50px;"></div>
                    <div style="font-size: 16px;font-weight: bold;color: #1e66d1;margin-top: 15px;text-align: center;">
                        数据模型封闭管理</div>
                    <div style="font-size: 14px;margin-top: 30px;">
                        所有数据存储与模型运行均在内部服务器完成，医疗、金融等高敏信息全程“不出门”；物理隔离环境杜绝云端传输风险，满足企业数据主权硬性要求</div>
                </div>
                <div style="height: 300px;width: 340px;padding: 0px 20px;">
                    <div style="margin-top: 35px;"><img src="../../assets/AI/AI_16.png"
                            style="margin:0px auto;height: 50px;"></div>
                    <div style="font-size: 16px;font-weight: bold;color: #1e66d1;margin-top: 15px;text-align: center;">
                        核心资产不泄露</div>
                    <div style="font-size: 14px;margin-top: 30px;">
                        模型参数与训练细节企业自主管控，结合硬件级加密防护；保护制造业工艺算法、零售用户画像等商业机密，杜绝技术泄密风险</div>
                </div>
                <div style="height: 300px;width: 340px;padding: 0px 20px;">
                    <div style="margin-top: 35px;"><img src="../../assets/AI/AI_17.png"
                            style="margin:0px auto;height: 50px;"></div>
                    <div style="font-size: 16px;font-weight: bold;color: #1e66d1;margin-top: 15px;text-align: center;">
                        量身定制业务效果</div>
                    <div style="font-size: 14px;margin-top: 30px;">
                        基于企业特有数据（如10万+维修工单）定向优化模型，精准识别行业术语（如“冷轧机跑偏”），关键任务准确率提升30%-50%，真正解决业务痛点</div>
                </div>
                <div style="height: 300px;width: 340px;padding: 0px 20px;">
                    <div style="margin-top: 35px;"><img src="../../assets/AI/AI_18.png"
                            style="margin:0px auto;height: 50px;"></div>
                    <div style="font-size: 16px;font-weight: bold;color: #1e66d1;margin-top: 15px;text-align: center;">
                        自主掌控灵活升级</div>
                    <div style="font-size: 14px;margin-top: 30px;">
                        支持按需热更新模型功能，政策变化3天内完成迭代；可自定义知识库同步策略，分部门部署差异化版本，摆脱厂商依赖
                    </div>
                </div>
                <div style="height: 300px;width: 340px;padding: 0px 20px;">
                    <div style="margin-top: 35px;"><img src="../../assets/AI/AI_19.png"
                            style="margin:0px auto;height: 50px;"></div>
                    <div style="font-size: 16px;font-weight: bold;color: #1e66d1;margin-top: 15px;text-align: center;">
                        本地运行快稳兼备</div>
                    <div style="font-size: 14px;margin-top: 30px;">
                        本地GPU集群实现千并发毫秒级响应，复杂任务处理效率提升3-5倍；断网仍可运行，全年故障率＜0.001%，保障业务连续性</div>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
export default {
    data() {
        return {
            index: 0,
            indexb: 0,
            indexc: 0
        }
    },
    mounted() {
    },
    methods: {
        tof(title) {
            this.$router.push({ name: 'AIMenu', query: { title: title } })
        },
        zhichiku() {
            var targetPosition = document.getElementById("section1").getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
                top: targetPosition - 60,
                behavior: 'smooth' // 平滑滚动效果
            });
            // var targetPosition = document.getElementById("section3").getBoundingClientRect().top + window.pageYOffset;
            // window.scrollTo({
            //     top: targetPosition,
            //     behavior: 'smooth' // 平滑滚动效果
            // });
        },
        znkfu() {
            var targetPosition = document.getElementById("section2").getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
                top: targetPosition - 60,
                behavior: 'smooth' // 平滑滚动效果
            });
            // var targetPosition = document.getElementById("section4").getBoundingClientRect().top + window.pageYOffset;
            // window.scrollTo({
            //     top: targetPosition-120,
            //     behavior: 'smooth' // 平滑滚动效果
            // });
        }
    }
}
</script>
<style scoped>
.slogan-text-font {
    font-size: 36px;
    display: flex;
    align-items: center;
}

.slogan-detail-card-title {
    font-size: 20px;
    display: relative;
}

.slogan-card {
    color: var(--color-content1);
    display: flex;
    height: 250px;
    width: 200px;
    flex-direction: column;
    align-items: center;
    border-radius: 1rem;
    background-color: rgb(255 255 255 / 0.8);
    padding-top: 2rem;
    padding-bottom: 2rem;
    font-size: 0.875rem;
    line-height: 1.75rem;
}

::v-deep #content p {
    text-indent: 2em;
    line-height: 35px;
    font-size: 16px;
}

::v-deep #content p:nth-child(2) {
    margin-top: 35px;
}

::v-deep #content p:nth-child(3) {
    margin-top: 35px;
}

.ai-yycj .div {
    width: 300px;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    text-align: center;
    border-radius: 15px 15px 0px 0px;
    cursor: pointer;
}

.ai-yycj .isdiv {
    font-weight: bold;
    background: #1e66d1;
    color: #fff;
}

.ai-gnzs div {
    width: 160px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 18px;
    color: #999999;
    background: #ebebeb;
    margin-bottom: 10px;
    border-radius: 10px;
    cursor: pointer;
}

.ai-gnzs .isdiv {
    background: #fff;
    color: #333;
}

.lifors:hover .buttondh {
    background: #1e66d1;
    color: #fff !important;
}

/* img{
  width:100%;
  height:100%;
} */
</style>
